module.exports = __webpack_public_path__ + "img/expense-purchase.4f3217ff.svg";